import RecentlyViewedGoods from './pages/RecentlyViewedGoods/RecentlyViewedGoods.page';
import type { ScreenItem } from 'shared/src/types';
import { GoodsDetailPage } from './pages/GoodsDetail';
import { isWeb } from 'shared/src/utils';
import { WEB_ROUTE_PATHS } from 'shared/src/webRoutePaths';

export const GoodsScreens: ScreenItem[] = [
  {
    name: 'RecentlyViewedGoods',
    component: RecentlyViewedGoods,
    path: WEB_ROUTE_PATHS.recentlyViewedGoods,
    options: {
      title: '최근 본 상품 - 에이블리 스토어',
    },
  },
  {
    name: 'GoodsDetail',
    component: GoodsDetailPage,
    path: WEB_ROUTE_PATHS.goodsDetail,
    options: {
      title: '상품 상세 - 에이블리 스토어',
    },
    convertParams: props => {
      const extras =
        typeof props.extras === 'string'
          ? JSON.parse(props.extras)
          : (props.extras ?? {});
      if (isWeb) {
        return {
          instanceId: props.instanceId,
          extras:
            typeof props.extras === 'string'
              ? JSON.parse(props.extras)
              : props.extras,
        };
      }

      return {
        instanceId: props.instanceId,
        goodsId:
          extras.sno ??
          extras.TARGET.goods_sno ??
          extras.TARGET.b ??
          extras.TARGET.b?.goods_sno ??
          extras.TARGET.c?.goods_sno,
        extras: extras,
      };
    },
  },
];
